import { useEffect, useRef } from "react";
import { KONAMI_SEQUENCE } from "../../data/easter-eggs";

export function useKonamiCode(onActivate: () => void) {
  const index = useRef(0);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === KONAMI_SEQUENCE[index.current]) {
        index.current++;
        if (index.current === KONAMI_SEQUENCE.length) {
          onActivate();
          index.current = 0;
        }
      } else {
        index.current = 0;
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onActivate]);
}
